import { render, staticRenderFns } from "./lgactivityriskorders.vue?vue&type=template&id=2856c87a&"
import script from "./lgactivityriskorders.vue?vue&type=script&lang=js&"
export * from "./lgactivityriskorders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports